import { FC } from 'react'
import { Box } from '@mui/material'
import { Icon } from 'packages/eid-icons'
import { getFullImageUrl } from 'utils'
import { Tooltip } from 'packages/eid-ui'
import { Instructions } from 'containers/ViewAllCsvInbox/CsvInboxDetail/Instructions'
import { useTranslation } from 'react-i18next'
import { isNilOrEmpty } from 'packages/core'
import { styled } from '@mui/material/styles'

export interface IApplicationImageProps {
    attribute: any
    data: any
    styles?: any
}
const StyledBox = styled(Box)(({ theme }) => ({
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '32px',
    paddingTop: '4px',
    paddingBottom: '4px',
}))

const StyledIcon = styled(Box)(({ theme }) => ({
    // Change Box to SvgIcon or specific icon component if necessary
    position: 'absolute',
    right: '-6px',
    top: '-6px',
}))

const ResourceImage: FC<IApplicationImageProps> = (props) => {
    const { t } = useTranslation()
    const { attribute, data, styles } = props
    const url = data.item[attribute.component.name]
    const defaultUrl = attribute.component.defaultUrl
    const getTooltipTitle = () => t('MoreInfo')
    return (
        <StyledBox>
            <img
                alt={t('ResourceImage')}
                style={{ ...styles }}
                src={
                    isNilOrEmpty(url)
                        ? getFullImageUrl(defaultUrl)
                        : getFullImageUrl(url)
                }
            />

            {data.instructions && (
                <Instructions
                    title={data.friendlyName}
                    instructions={data.instructions}
                    button={(onClick: any) => (
                        <Tooltip title={getTooltipTitle()}>
                            <StyledIcon onClick={() => onClick(true)}>
                                <Icon
                                    name="Info"
                                    color="#8b909a"
                                    width="12px"
                                    height="12px"
                                />
                            </StyledIcon>
                        </Tooltip>
                    )}
                />
            )}
        </StyledBox>
    )
}
export default ResourceImage
